import styled from "styled-components";

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 15px;
  font-family: "League Spartan", sans-serif;
  font-size: 25px;
  color: #a91212ff;
  text-align: center;

  svg {
    font-size: 35px;
    color: #7a3e3eff;
  }
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  overflow: hidden;
  background: #f2f2f2;
  aspect-ratio: 1 / 1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  }
`;

export const GifImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 25px;
`;

export const PageButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  border: none;
  background: #222;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
